/*
 OTAExample.css
 =========

------------------------------------------------------------------------
 Author:   Oskar Truffer                                        2025
 Modifs:

 Goal:   Demonstrator CSS for FUOTA status tracking & management for TRACE.

   (c) 2025  Oskar Truffer   
   --------------------------

   CSEM S.A.
   Jaquet-Droz 1
   CH-2000 Neuchâtel
   http://www.csem.ch


   THIS SOFTWARE IS CONFIDENTIAL AND CANNOT BE DISTRIBUTED
   WITHOUT THE CSEM PRIOR WRITTEN AGREEMENT.

   THIS  SOFTWARE CAN ONLY BE USED IN THE EUROPEAN PROJECT TRACE AND
   SHALL REMAIN PRIVATE AT ALL TIMES.

------------------------------------------------------------------------
*/

import { Axios } from "axios";
import { Auth } from 'aws-amplify';
import awsResources from "../aws-resources.json";
  

export type API = Axios;

  export function createClient(): API {
    const baseURL = new URL(awsResources.RestApiEndpoint);

    // For some reason, axios default content-type is application/x-www-form-urlencoded
    const defaultHeaders = {
        "Content-Type": "application/json",
    };

    const client = new Axios({
        baseURL: baseURL.toString(),
        headers: defaultHeaders,
    });

    
    client.interceptors.request.use(async (config) => {
        const session = await Auth.currentSession();
        if (session == null) {
            throw new Error("We try to attach http authorization headers but we're not logged in.");
        }
        
        let idToken = session.getIdToken().getJwtToken();

        config.headers['Authorization'] = `Bearer ${idToken}`

        return config;
    });

    return client;
}